
require('./bootstrap');

// CSS
import scss from './scss/styles.scss'

import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import {routes} from './lib/routes'

// require('./keys');

Vue.use(VueRouter);

global.router = new VueRouter({
    routes,
});

const app = new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js